const model = {
    id: null,
    loading: false,
    error: null,
};

export default model;
